<div style="padding-top: 1%;">
    <span ><b>Welcome </b>  {{userFromApi.Name}}</span>
</div>
<br>
<div *ngIf ="!flgLock" style="padding-top: 3%">
    <b>SA Accrual Management System </b> is a tool to record and recognize expenses and matching them to the period in which
     they are incurred.<br>
     It is also easier and faster system in which value of work done submitted online are automatically reviewed and booked in an efficient and orderly manner
</div>
<div *ngIf ="flgLock" style="padding-top: 3%">
    <b>Accrual Management System is now lockdown for submission, resumes next month</b>
</div>
<div style="padding-top: 10%;width: 30%;" *ngIf="!isProd">
    <div class="panel panel-primary" sty>
        <div class="panel-heading">Enter Provisioning ID</div>
        <div class="panel-body">
             <input type="text"  [(ngModel)]="ProvisioningID"> &nbsp;
             <button class="btn btn-primary " (click)="submit()">Submit</button> &nbsp;
        </div>
    </div>

</div>